import React from 'react';
import './productLayout.scss';

export default () => (
<div className="product-layout" />
);